const authLanguages = {
  hu: {
    error: {
      forgotPassword: {
        too_many_requests:
          'Elérte a jelszóváltoztatási probálkozások engedélyezett számát. Kérjük, várjon mielőtt újrapróbálkozna!',
        'lock.fallback': 'Sajnáljuk, valami hiba történt a jelszóváltoztatás során.',
        enterprise_email:
          'Az e-mail domainje egy Enterprise azonosító szolgáltató része. A jelszó visszaállításához kérjük, olvassa el a biztonsági dokumentációt.'
      },
      login: {
        blocked_user: 'A felhasználó nincs engedélyezve.',
        invalid_user_password: 'Hibás bejelentkezés.',
        'lock.fallback': 'Valami hiba történt a bejelentkezés során.',
        'lock.invalid_code': 'Hibás PIN.',
        'lock.invalid_email_password': 'Hibás e-mail vagy jelszó.',
        'lock.invalid_username_password': 'Hibás felhasználónév vagy jelszó.',
        'lock.network': 'A szerver nem elérhető. Kérjük, ellenőrizze az internetkapcsolatot, és próbálja újra!',
        'lock.popup_closed': 'A felugró ablak be lett zárva. Kérjük, próbálja újra!',
        'lock.unauthorized': 'Engedély megtagadva. Kérjük, próbálja újra!',
        password_change_required: 'Jelszóváltoztatás szükséges, első belépés vagy lejárt jelszó végett.',
        password_leaked:
          'Az azonosítót letiltottuk, mert a hozzá tartozó jelszó egy másik honlapon nyilvánosságra került. Küldtünk Önnek egy e-mailt az azonosító engedélyezésének menetéről.',
        too_many_attempts: 'Több bejelentkezési kísérlet után az azonosítóját letiltottuk.',
        'lock.mfa_registration_required':
          'Többtényezős hitelesítés szükséges, kérjük regisztrálja a készüléket a hitelesítés megkezdése előtt.',
        'lock.mfa_invalid_code': 'Helytelen kód. Kérjük, próbálja újra.',
        session_missing:
          'Nem tudjuk teljesíteni a hitelesítési kérelmet. Kérjük zárja be a párbeszédablakokat és próbálja újra',
        'hrd.not_matching_email': 'Kérjük, használja a vállalati e-mail-címét a bejelentkezéshez.'
      },
      passwordless: {
        'bad.email': 'Érvénytelen e-mail-cím',
        'bad.phone_number': 'Érvénytelen telefonszám',
        'lock.fallback': 'Sajnáljuk, valami hiba történt'
      },
      signUp: {
        invalid_password: 'Érvénytelen jelszó.',
        'lock.fallback': 'Sajnáljuk, a feliratkozás során valami hiba történt.',
        password_dictionary_error: 'Túl gyakori jelszó.',
        password_no_user_info_error: 'A jelszó a felhasználói adatokra támaszkodik.',
        password_strength_error: 'Túl gyenge jelszó.',
        user_exists: 'A felhasználó már létezik.',
        username_exists: 'A felhasználónév már foglalt.'
      }
    },
    success: {
      logIn: 'Köszönjük a bejelentkezését',
      forgotPassword: 'Küldtünk Önnek egy e-mailt a jelszó visszaállításának menetéről.',
      magicLink: 'E-mailben kiküldtük a bejelentkezési linket<br />a %s honlaphoz.',
      signUp: 'Köszönjük, hogy feliratkozott.'
    },
    blankErrorHint: 'Nem lehet üres',
    codeInputPlaceholder: 'PIN',
    databaseEnterpriseLoginInstructions: '',
    databaseEnterpriseAlternativeLoginInstructions: 'vagy',
    databaseSignUpInstructions: '',
    databaseAlternativeSignUpInstructions: 'vagy',
    emailInputPlaceholder: 'emailcim@example.com',
    enterpriseLoginIntructions: 'Bejelentkezés céges azonosítóval.',
    enterpriseActiveLoginInstructions: 'Kérjük, adja meg a céges azonosítóját a %s honlapon.',
    failedLabel: 'Sikertelen!',
    forgotPasswordAction: 'Elfelejtett jelszó',
    forgotPasswordInstructions:
      'Kérjük, adja meg az e-mail-címét, ahova kiküldjük a jelszó helyreállítás további menetét!',
    forgotPasswordSubmitLabel: 'E-mail küldése',
    invalidErrorHint: 'Érvénytelen',
    lastLoginInstructions: 'Utolsó bejelentkezés',
    loginAtLabel: 'Bejelentkezés ideje: %s',
    loginLabel: 'Belépés',
    loginSubmitLabel: 'Belépés',
    loginWithLabel: 'Belépés %s-val',
    notYourAccountAction: 'Nem az Ön fiókja?',
    passwordInputPlaceholder: 'Jelszó',
    passwordStrength: {
      containsAtLeast: 'Legalább %d alkalommal tartalmazza a következő %d karaktert:',
      identicalChars: 'Legfeljebb %d azonos karakter szerepelhet egy sorban (pl. "%s" nem engedélyezett)',
      nonEmpty: 'A jelszó nem lehet üres',
      numbers: 'Számok (0-9)',
      lengthAtLeast: 'Legalább %d hosszú',
      lowerCase: 'Kisbetűk (a-z)',
      shouldContain: 'Tartalmazzon:',
      specialCharacters: 'Különleges karakterek (e.g. !@#$%^&*)',
      upperCase: 'Nagybetűk (A-Z)'
    },
    passwordlessEmailAlternativeInstructions: 'Bejelentkezéshez vagy feliratkozáshoz<br/>adja meg az e-mail-címét',
    passwordlessEmailCodeInstructions: 'A PIN-t e-mailben elküldük a %s címre.',
    passwordlessEmailInstructions: 'Bejelentkezéshez vagy feliratkozáshoz<br/>adja meg az e-mail-címét',
    passwordlessSMSAlternativeInstructions: 'Bejelentkezéshez vagy feliratkozáshoz<br/>adja meg a telefonszámát',
    passwordlessSMSCodeInstructions: 'A PIN-t SMS-ben elküldtük a %s számra.',
    passwordlessSMSInstructions: 'Bejelentkezéshez vagy feliratkozáshoz<br/>adja meg a telefonszámát',
    phoneNumberInputPlaceholder: 'telefonszáma',
    resendCodeAction: 'Nem kapta meg a PIN-t?',
    resendLabel: 'Újraküldés',
    resendingLabel: 'Újraküldés...',
    retryLabel: 'Kérjük, próbálja újra',
    sentLabel: 'Elküldve!',
    signUpLabel: 'Feliratkozás',
    signUpSubmitLabel: 'Feliratkozás',
    signUpWithLabel: 'Feliratkozás %s-val',
    socialLoginInstructions: '',
    socialSignUpInstructions: '',
    ssoEnabled: 'Egyszeri bejelentkezés engedélyezve',
    submitLabel: 'Mehet',
    unrecoverableError: 'Valami hiba történt.<br />Kérjük, lépjen kapcsolatba a műszaki ügyfélszolgálattal.',
    usernameFormatErrorHint: 'Használj %d-%d betűket, számokat és a következő karaktereket: "_", ".", "+", "-"',
    usernameInputPlaceholder: 'felhasználóneve',
    usernameOrEmailInputPlaceholder: 'felhasználónév/e-mail',
    title: 'Bejelentkezés',
    welcome: 'Üdvözöljük %s!',
    windowsAuthInstructions: 'A céges hálózatával kapcsolódik&hellip;',
    windowsAuthLabel: 'Windows bejelentkezés',
    forgotPasswordTitle: 'Kérjük, állítsa vissza a jelszavát',
    signUpTitle: 'Regisztráljon',
    mfaInputPlaceholder: 'Kód',
    mfaLoginTitle: 'Kétlépcsős azonosítás',
    mfaLoginInstructions: 'Kérjük adja meg az ellenőrző kódot, amit a mobil alkalmazás generált.',
    mfaSubmitLabel: 'Belépés',
    mfaCodeErrorHint: 'Használja %d számok',
    showPassword: 'Jelszó megjelenítése',
    signUpTerms: 'Feliratkozással elfogadja a szolgáltatási feltételeinket és az adatvédelmi irányelveinket.'
  },
  en: {
    error: {
      forgotPassword: {
        too_many_requests: 'You have reached the limit on password change attempts. Please wait before trying again.',
        'lock.fallback': "We're sorry, something went wrong when requesting the password change.",
        enterprise_email:
          "Your email's domain is part of an Enterprise identity provider. To reset your password, please see your security administrator."
      },
      login: {
        blocked_user: 'The user is blocked.',
        invalid_user_password: 'Wrong credentials.',
        'lock.fallback': "We're sorry, something went wrong when attempting to log in.",
        'lock.invalid_code': 'Wrong code.',
        'lock.invalid_email_password': 'Wrong email or password.',
        'lock.invalid_username_password': 'Wrong username or password.',
        'lock.network': 'We could not reach the server. Please check your connection and try again.',
        'lock.popup_closed': 'Popup window closed. Try again.',
        'lock.unauthorized': 'Permissions were not granted. Try again.',
        'lock.mfa_registration_required':
          'Multifactor authentication is required but your device is not enrolled. Please enroll it before moving on.',
        'lock.mfa_invalid_code': 'Wrong code. Please try again.',
        password_change_required:
          'You need to update your password because this is the first time you are logging in, or because your password has expired.', // TODO: verify error code
        password_leaked:
          'We have detected a potential security issue with this account. To protect your account, we have blocked this login. An email was sent with instruction on how to unblock your account.',
        too_many_attempts: 'Your account has been blocked after multiple consecutive login attempts.',
        session_missing:
          "Couldn't complete your authentication request. Please try again after closing all open dialogs",
        'hrd.not_matching_email': 'Please use your corporate email to login.'
      },
      passwordless: {
        'bad.email': 'The email is invalid',
        'bad.phone_number': 'The phone number is invalid',
        'lock.fallback': "We're sorry, something went wrong"
      },
      signUp: {
        invalid_password: 'Password is invalid.',
        'lock.fallback': "We're sorry, something went wrong when attempting to sign up.",
        password_dictionary_error: 'Password is too common.',
        password_no_user_info_error: 'Password is based on user information.',
        password_strength_error: 'Password is too weak.',
        user_exists: 'The user already exists.',
        username_exists: 'The username already exists.'
      }
    },
    success: {
      // success messages show above the form or in a confirmation pane
      logIn: 'Thanks for logging in.',
      forgotPassword: "We've just sent you an email to reset your password.",
      magicLink: 'We sent you a link to log in<br />to %s.',
      signUp: 'Thanks for signing up.'
    },
    blankErrorHint: "Can't be blank",
    codeInputPlaceholder: 'your code',
    databaseEnterpriseLoginInstructions: '',
    databaseEnterpriseAlternativeLoginInstructions: 'or',
    databaseSignUpInstructions: '',
    databaseAlternativeSignUpInstructions: 'or',
    emailInputPlaceholder: 'yours@example.com',
    enterpriseLoginIntructions: 'Login with your corporate credentials.',
    enterpriseActiveLoginInstructions: 'Please enter your corporate credentials at %s.',
    failedLabel: 'Failed!',
    forgotPasswordTitle: 'Reset your password',
    forgotPasswordAction: "Don't remember your password?",
    forgotPasswordInstructions: 'Please enter your email address. We will send you an email to reset your password.',
    forgotPasswordSubmitLabel: 'Send email',
    invalidErrorHint: 'Invalid',
    lastLoginInstructions: 'Last time you logged in with',
    loginAtLabel: 'Log in at %s',
    loginLabel: 'Log In',
    loginSubmitLabel: 'Log In',
    loginWithLabel: 'Log in with %s',
    notYourAccountAction: 'Not your account?',
    passwordInputPlaceholder: 'your password',
    passwordStrength: {
      containsAtLeast: 'Contain at least %d of the following %d types of characters:',
      identicalChars: 'No more than %d identical characters in a row (e.g., "%s" not allowed)',
      nonEmpty: 'Non-empty password required',
      numbers: 'Numbers (i.e. 0-9)',
      lengthAtLeast: 'At least %d characters in length',
      lowerCase: 'Lower case letters (a-z)',
      shouldContain: 'Should contain:',
      specialCharacters: 'Special characters (e.g. !@#$%^&*)',
      upperCase: 'Upper case letters (A-Z)'
    },
    passwordlessEmailAlternativeInstructions: 'Otherwise, enter your email to sign in<br/>or create an account',
    passwordlessEmailCodeInstructions: 'An email with the code has been sent to %s.',
    passwordlessEmailInstructions: 'Enter your email to sign in<br/>or create an account',
    passwordlessSMSAlternativeInstructions: 'Otherwise, enter your phone to sign in<br/>or create an account',
    passwordlessSMSCodeInstructions: 'An SMS with the code has been sent<br/>to %s.',
    passwordlessSMSInstructions: 'Enter your phone to sign in<br/>or create an account',
    phoneNumberInputPlaceholder: 'your phone number',
    resendCodeAction: 'Did not get the code?',
    resendLabel: 'Resend',
    resendingLabel: 'Resending...',
    retryLabel: 'Retry',
    sentLabel: 'Sent!',
    showPassword: 'Show password',
    signUpTitle: 'Sign Up',
    signUpLabel: 'Sign Up',
    signUpSubmitLabel: 'Sign Up',
    signUpTerms: 'By signing up, you agree to our terms of service and privacy policy.',
    signUpWithLabel: 'Sign up with %s',
    socialLoginInstructions: '',
    socialSignUpInstructions: '',
    ssoEnabled: 'Single Sign-On enabled',
    submitLabel: 'Submit',
    unrecoverableError: 'Something went wrong.<br />Please contact technical support.',
    usernameFormatErrorHint: 'Use %d-%d letters, numbers and the following characters: "_", ".", "+", "-"',
    usernameInputPlaceholder: 'your username',
    usernameOrEmailInputPlaceholder: 'username/email',
    title: 'Login',
    welcome: 'Welcome %s!',
    windowsAuthInstructions: 'You are connected from your corporate network&hellip;',
    windowsAuthLabel: 'Windows Authentication',
    mfaInputPlaceholder: 'Code',
    mfaLoginTitle: '2-Step Verification',
    mfaLoginInstructions: 'Please enter the verification code generated by your mobile application.',
    mfaSubmitLabel: 'Log In',
    mfaCodeErrorHint: 'Use %d numbers'
  },
  de: {
    error: {
      forgotPassword: {
        too_many_requests:
          'Sie haben das Limit für Rücksetzungsversuche des Passworts erreicht. Bitte warten Sie, bevor Sie es erneut versuchen.',
        'lock.fallback': 'Es tut uns leid, beim Zurücksetzen des Passworts ist ein Fehler aufgetreten.',
        enterprise_email:
          'Die Domain Ihrer E-Mail-Adresse ist Teil eines Enterprise Identity Providers. Um Ihr Passwort zurückzusetzen, wenden Sie sich bitte an Ihren Sicherheitsadministrator.'
      },
      login: {
        blocked_user: 'Der Benutzer wird blockiert.',
        invalid_user_password: 'Falsche Anmeldeinformationen.',
        'lock.fallback': 'Es tut uns leid, beim Verarbeiten der Anmeldung ist ein Fehler aufgetreten.',
        'lock.invalid_code': 'Falscher Code.',
        'lock.invalid_email_password': 'Falsche E-Mail-Adresse oder Passwort.',
        'lock.invalid_username_password': 'Falscher Benutzername oder Passwort.',
        'lock.network': 'Der Server antwortet nicht.<br/>Bitte erneut versuchen.',
        'lock.popup_closed': 'Pop-up-Fenster geschlossen. Versuchen Sie es erneut.',
        'lock.unauthorized': 'Genehmigungen wurden nicht erteilt. Versuchen Sie es erneut.',
        'lock.mfa_registration_required':
          'Eine Multifaktor-Authentifizierung ist erforderlich, aber Ihr Gerät ist nicht registriert. Bitte registrieren Sie es, bevor Sie fortfahren.',
        'lock.mfa_invalid_code': 'Falscher Code. Bitte versuchen Sie es erneut.',
        password_change_required:
          'Sie müssen Ihr Passwort ändern, da Sie sich zum ersten Mal anmelden oder das Passwort abgelaufen ist.',
        password_leaked:
          // tslint:disable-next-line:max-line-length
          'Wir haben ein potenzielles Sicherheitsproblem mit diesem Konto festgestellt. Um Ihr Konto zu schützen, haben wir diese Anmeldung blockiert. Es wurde eine E-Mail mit einer Anleitung zum Entsperren Ihres Kontos gesendet.',
        too_many_attempts: 'Ihr Konto wurde nach mehreren aufeinander folgenden Anmeldeversuche gesperrt.',
        session_missing:
          'Ihre Authentifizierungsanfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut, nachdem Sie alle geöffneten Dialoge geschlossen haben.',
        'hrd.not_matching_email': 'Bitte verwenden Sie Ihre geschäftliche E-Mail-Adresse, um sich anzumelden.'
      },
      passwordless: {
        'bad.email': 'Diese E-Mail-Adresse ist ungültig',
        'bad.phone_number': 'Diese Telefonnummer ist ungültig',
        'lock.fallback': 'Es tut uns leid, etwas ist schiefgelaufen.'
      },
      signUp: {
        invalid_password: 'Passwort ist ungültig.',
        'lock.fallback': 'Es tut uns leid, beim Verarbeiten der Registrierung ist ein Fehler aufgetreten.',
        password_dictionary_error: 'Das Passwort ist zu verbreitet.',
        password_no_user_info_error: 'Das Passwort basiert auf Benutzerinformationen.',
        password_strength_error: 'Das Passwort ist zu schwach.',
        user_exists: 'Der Nutzer existiert bereits.',
        username_exists: 'Der Nutzername wird bereits verwendet.'
      }
    },
    success: {
      logIn: 'Danke für die Anmeldung.',
      forgotPassword: 'Wir haben Ihnen eine E-Mail gesendet, um Ihr Passwort zurückzusetzen.',
      magicLink: 'Wir haben Ihnen einen Link geschickt, zur Anmeldung<br/>bei %s.',
      signUp: "Vielen Dank für's Registrieren."
    },
    blankErrorHint: 'Darf nicht leer sein',
    codeInputPlaceholder: 'Ihr Code',
    databaseEnterpriseLoginInstructions: '',
    databaseEnterpriseAlternativeLoginInstructions: 'oder',
    databaseSignUpInstructions: '',
    databaseAlternativeSignUpInstructions: 'oder',
    emailInputPlaceholder: 'ihremail@example.com',
    enterpriseLoginIntructions: 'Melden Sie sich mit Ihren geschäftlichen Informationen an.',
    enterpriseActiveLoginInstructions: 'Bitte geben Sie Ihre geschäftlichen Informationen bei %s an.',
    failedLabel: 'Gescheitert!',
    forgotPasswordTitle: 'Bitte, setze dein Passwort zurück',
    forgotPasswordAction: 'Passwort vergessen?',
    forgotPasswordInstructions:
      'Bitte, geben Sie die e-mail Adresse ein, an die Sie die Nachricht zur Passwortwiederherstellung senden möchten.',
    forgotPasswordSubmitLabel: 'E-Mail Versand',
    invalidErrorHint: 'Ungültig!',
    lastLoginInstructions: 'Letztes Mal waren Sie angemeldet mit',
    loginAtLabel: 'Anmelden bei %s',
    loginLabel: 'Eintrag',
    loginSubmitLabel: 'Eintrag',
    loginWithLabel: 'Eintrag mit %s',
    notYourAccountAction: 'Falsches Konto?',
    passwordInputPlaceholder: 'Ihr Passwort',
    passwordStrength: {
      containsAtLeast: 'Enthält mindestens %d der folgenden %d Arten von Zeichen:',
      identicalChars: 'Nicht mehr als %d identische Zeichen in Folge (z. B. "%s" ist nicht erlaubt)',
      nonEmpty: 'Das Passwort darf nicht leer sein',
      numbers: 'Zahlen (z. B. 0-9)',
      lengthAtLeast: 'Muss mindestens %d Zeichen lang sein',
      lowerCase: 'Kleinbuchstaben (a-z)',
      shouldContain: 'Sollte enthalten:',
      specialCharacters: 'Sonderzeichen (z. B. !@#$%^&*)',
      upperCase: 'Großbuchstaben (A-Z)'
    },
    passwordlessEmailAlternativeInstructions:
      'Andernfalls geben Sie Ihre E-Mail-Adresse ein,<br/>um sich anzumelden oder ein Konto zu erstellen',
    passwordlessEmailCodeInstructions: 'Eine E-Mail mit dem Code wurde an %s gesendet.',
    passwordlessEmailInstructions:
      'Geben Sie Ihre E-Mail-Adresse ein, um sich anzumelden<br/>oder ein Konto zu erstellen',
    passwordlessSMSAlternativeInstructions:
      'Andernfalls geben Sie Ihre Telefonnummer ein,<br>um sich anzumelden oder ein Konto zu erstellen',
    passwordlessSMSCodeInstructions: 'Eine SMS mit dem Code wurde gesendet<br/>an %s.',
    passwordlessSMSInstructions: 'Geben Sie Ihre Telefonnummer ein,<br>um sich anzumelden oder ein Konto zu erstellen',
    phoneNumberInputPlaceholder: 'Ihre Telefonnummer',
    resendCodeAction: 'Haben Sie den Code nicht erhalten?',
    resendLabel: 'Erneut senden',
    resendingLabel: 'Wird erneut gesendet...',
    retryLabel: 'Wiederholen',
    sentLabel: 'Gesendet!',
    showPassword: 'Passwort anzeigen',
    signUpTitle: 'Anmelden',
    signUpLabel: 'Registrieren',
    signUpSubmitLabel: 'Registrieren',
    signUpWithLabel: 'Registrieren mit %s',
    socialLoginInstructions: '',
    socialSignUpInstructions: '',
    ssoEnabled: 'Single Sign-On aktiviert',
    submitLabel: 'Absenden',
    unrecoverableError: 'Etwas ist schiefgelaufen.<br/>Bitte kontaktieren Sie den technischen Support.',
    usernameFormatErrorHint: 'Verwenden Sie %d-%d Buchstaben, Zahlen und die folgenden Zeichen: "_", ".", "+", "-"',
    usernameInputPlaceholder: 'Ihr Benutzername',
    usernameOrEmailInputPlaceholder: 'Benutzername/E-Mail-Adresse',
    title: 'Einloggen',
    welcome: 'Willkommen %s!',
    windowsAuthInstructions: 'Sie sind über Ihr Firmennetzwerk verbunden&hellip;',
    windowsAuthLabel: 'Windows Authentifizierung',
    mfaInputPlaceholder: 'Code',
    mfaLoginTitle: 'Multifaktor-Authentifizierung',
    mfaLoginInstructions: 'Bitte geben Sie den Bestätigungscode ein, der von Ihrer mobilen Anwendung generiert wurde.',
    mfaSubmitLabel: 'Eintrag',
    mfaCodeErrorHint: 'Verwenden %d Zahlen',
    signUpTerms: 'Mit der Anmeldung stimmen Sie unseren Nutzungsbedingungen und Datenschutzbestimmungen zu.'
  },
  fr: {
    error: {
      forgotPassword: {
        too_many_requests:
          'Vous avez atteint la limite de tentatives de changement de mot de passe. Veuillez patienter avant de recommencer.',
        'lock.fallback':
          'Nous sommes désolés, un problème est survenu lors de la demande de changement de mot de passe.',
        enterprise_email:
          "Le domaine de votre messagerie fait partie d'un fournisseur d'identité d'entreprise. Pour réinitialiser votre mot de passe, veuillez contacter votre administrateur de sécurité."
      },
      login: {
        blocked_user: 'L’utilisateur est bloqué.',
        invalid_user_password: 'Mauvais identifiants.',
        'lock.fallback': 'Nous sommes désolés, un problème est survenu lors de la tentative de connexion.',
        'lock.invalid_code': 'Mauvais code.',
        'lock.invalid_email_password': 'Mauvaise adresse de messagerie ou mot de passe.',
        'lock.invalid_username_password': 'Mauvais nom d’utilisateur ou mot de passe.',
        'lock.network': 'Nous ne pouvons pas joindre le serveur. Vérifiez votre connexion et réessayez.',
        'lock.popup_closed': 'La fenêtre popup a été fermée. Veuillez réessayer.',
        'lock.unauthorized': 'Les permissions n’ont pas été accordées. Veuillez réessayer.',
        password_change_required:
          'Vous devez mettre à jour votre mot de passe, soit parce qu’il s’agit de votre première connexion, soit parce que ce dernier a expiré.',
        password_leaked:
          'Cette connexion a été bloquée parce que votre mot de passe a été utilisé sur un autre site web. Nous vous avons envoyé un courriel avec des instructions pour la débloquer.',
        too_many_attempts:
          'Votre compte a été bloqué à la suite de trop nombreuses tentatives de connexion consécutives.',
        'lock.mfa_registration_required':
          "l'authentification multifactorielle est nécessaire, mais votre appareil n'est pas inscrit. Veuillez vous inscrire avant de passer.",
        'lock.mfa_invalid_code': 'Mauvais code. Veuillez réessayer.',
        session_missing:
          "Impossible de terminer votre demande d'authentification. Veuillez essayer de nouveau après la fermeture de tous les dialogues ouverts",
        'hrd.not_matching_email': "Veuillez utiliser votre messagerie d'entreprise pour vous connecter.",
        too_many_requests:
          'Nous sommes désolés. Il y a trop de demandes en ce moment. Veuillez recharger la page et réessayer. Si cela persiste, veuillez réessayer ultérieurement.',
        invalid_captcha: "Résolvez la question du défi pour vérifier que vous n'êtes pas un robot.",
        invalid_recaptcha: "Cochez la case pour vérifier que vous n'êtes pas un robot."
      },
      passwordless: {
        'bad.email': 'L’adresse de messagerie n’est pas valide',
        'bad.phone_number': 'Le numéro de téléphone n’est pas valide',
        'lock.fallback': 'Nous sommes désolés, un problème est survenu'
      },
      signUp: {
        invalid_password: 'Le mot de passe n’est pas valide.',
        'lock.fallback': 'Nous sommes désolés, un problème est survenu lors de la tentative d’inscription.',
        password_dictionary_error: 'Le mot de passe est trop commun.',
        password_no_user_info_error: 'Le mot de passe est basé sur des informations utilisateur.',
        password_strength_error: 'La force du mot de passe est trop faible.',
        user_exists: 'Cet utilisateur existe déjà.',
        username_exists: 'Ce nom d’utilisateur existe déjà.',
        social_signup_needs_terms_acception: "Veuillez accepter les conditions d'utilisation ci-dessous pour continuer."
      }
    },
    success: {
      logIn: 'Merci de vous être connecté.',
      forgotPassword: 'Nous venons de vous envoyer un courriel pour réinitialiser votre mot de passe.',
      magicLink: 'Nous vous avons envoyé un lien pour vous connecter<br />à %s.',
      signUp: 'Merci de vous être inscrit.'
    },
    blankErrorHint: '',
    blankPasswordErrorHint: 'Ne peut être vide',
    blankEmailErrorHint: 'Ne peut être vide',
    blankUsernameErrorHint: 'Ne peut être vide',
    blankCaptchaErrorHint: 'Ne peut être vide',
    codeInputPlaceholder: 'votre code',
    databaseEnterpriseLoginInstructions: '',
    databaseEnterpriseAlternativeLoginInstructions: 'ou',
    databaseSignUpInstructions: '',
    databaseAlternativeSignUpInstructions: 'ou',
    emailInputPlaceholder: 'votreadresse@exemple.com',
    enterpriseLoginIntructions: 'Connectez-vous avec vos identifiants d’entreprise.',
    enterpriseActiveLoginInstructions: 'Veuillez entrer les identifiants de connexion de votre entreprise %s.',
    failedLabel: 'A échoué !',
    forgotPasswordAction: 'Mot de passe oublié ?',
    forgotPasswordInstructions:
      'Veuillez entrer votre adresse e-mail, où nous vous enverrons la suite du processus de récupération du mot de passe !',
    forgotPasswordSubmitLabel: 'Envoyer un e-mail',
    invalidErrorHint: '',
    invalidPasswordErrorHint: 'Invalide',
    invalidEmailErrorHint: 'Invalide',
    invalidUsernameErrorHint: 'Invalide',
    lastLoginInstructions: 'Dernière connexion avec',
    loginAtLabel: 'Connexion à %s',
    loginLabel: 'Entrée',
    loginSubmitLabel: 'Entrée',
    loginWithLabel: 'Entrée avec %s',
    notYourAccountAction: 'Ceci n’est pas votre compte ?',
    passwordInputPlaceholder: 'Votre mot de passe',
    passwordStrength: {
      containsAtLeast: 'Doit contenir au moins %d des %d types de caractères :',
      identicalChars: 'Pas plus de %d caractères identiques dans une ligne (par ex., « %s » n’est pas autorisé)',
      nonEmpty: 'Mot de passe non vide requis',
      numbers: 'Chiffres  (i.e. 0-9)',
      lengthAtLeast: 'Au moins %d caractères',
      lowerCase: 'Lettres minuscules (a-z)',
      shouldContain: 'Doit contenir :',
      specialCharacters: 'Caractères spéciaux (par ex. !@#$%^&*)',
      upperCase: 'Lettres majuscules (A-Z)'
    },
    passwordlessEmailAlternativeInstructions:
      'Sinon entrez votre adresse de messagerie pour vous connecter<br/>ou créez un compte',
    passwordlessEmailCodeInstructions: 'Un courriel avec le code a été envoyé à %s.',
    passwordlessEmailInstructions: 'Entrez votre adresse de messagerie pour vous connecter<br/>ou créez un compte',
    passwordlessSMSAlternativeInstructions:
      'Sinon saisissez votre numéro de téléphone pour vous connecter<br/>ou créez un compte',
    passwordlessSMSCodeInstructions: 'Un SMS avec le code a été envoyé à %s.',
    passwordlessSMSInstructions: 'Saisissez votre numéro de téléphone pour vous connecter<br/>ou créez un compte',
    phoneNumberInputPlaceholder: 'votre numéro de téléphone',
    resendCodeAction: 'Vous n’avez pas reçu le code ?',
    resendLabel: 'Envoyer une nouvelle fois',
    resendingLabel: 'Nouvel envoi en cours…',
    retryLabel: 'Réessayer',
    sentLabel: 'Envoyé !',
    signUpLabel: 'Inscription',
    signUpSubmitLabel: 'Inscription',
    signUpWithLabel: 'S’inscrire avec %s',
    socialLoginInstructions: '',
    socialSignUpInstructions: '',
    ssoEnabled: 'Authentification unique activée',
    submitLabel: 'Envoyer',
    unrecoverableError: 'Un problème est survenu.<br />Veuillez contacter l’assistance technique.',
    usernameFormatErrorHint: 'Utilisez %d-%d lettres, chiffres et les caractères suivants: "_", ".", "+", "-"',
    usernameInputPlaceholder: 'votre nom d’utilisateur',
    usernameOrEmailInputPlaceholder: 'nom d’utilisateur/adresse de messagerie',
    title: 'Connexion',
    welcome: 'Bienvenue %s !',
    windowsAuthInstructions: 'Vous êtes connecté depuis votre réseau d’entreprise...',
    windowsAuthLabel: 'Authentification Windows',
    forgotPasswordTitle: 'Veuillez réinitialiser votre mot de passe',
    signUpTitle: "S'inscrire",
    mfaInputPlaceholder: 'Code',
    mfaLoginTitle: '2-Step Vérification',
    mfaLoginInstructions: 'Veuillez entrer le code de vérification généré par votre application mobile.',
    mfaSubmitLabel: 'Entrée',
    mfaCodeErrorHint: 'Utilisez des numéros %d',
    showPassword: 'Montrer le mot de passe',
    signUpTerms:
      "En vous inscrivant, vous acceptez nos conditions d'utilisation et notre politique de confidentialité.",
    captchaCodeInputPlaceholder: 'Entrez le code ci-dessus',
    captchaMathInputPlaceholder: 'Résolvez la formule ci-dessus'
  }
};

export default authLanguages;